<template>
  <div class="info-list">
    <template v-if="list.length">
      <div
        @click="clickItem(item)"
        class="mk"
        :class="[{ active: item.active }, 'infoList-' + index]"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="mk-title">
          <i class="icon iconfont" :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </div>
        <div class="mk-body" v-if="item.value.length">
          <template v-for="(unscrambles, h_index) in item.value">
            <mkBodyItem :unscrambles="unscrambles" :key="h_index" />
          </template>
        </div>
        <empty v-else />
      </div>
    </template>
    <empty v-else />
  </div>
</template>

<script>
import mkBodyItem from "./mkBodyItem.vue";
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    mkBodyItem,
  },
  methods: {
    clickItem(item) {
      this.$emit("clickItem", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.info-list {
}
</style>